import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { ModalService } from '@ds/core';
import {
  BlockTypeImage,
  BlockTypeSlider,
  ImageContentBlock,
  Inventory,
  SectionContentBlock,
  SliderContentBlock,
  WebsiteEmailEntry,
  WebsiteEmailEntryType,
} from '@ds/interfaces';
import { ContentBlockContactFormComponent } from '../content-block-contact-card/content-block-contact-form.component';
import { ContentBlockInventoryService } from './content-block-inventory.service';

@Component({
  selector: 'ds-cb-inventory-detail',
  template: `
    <ds-cb-section *ngIf="isLegacy" class="legacy">
      <div class="ds-row">
        <div class="ds-col-sm-6 ds-col-md-4">
          <ds-cb-link [route]="searchLink" text="Back To Search"></ds-cb-link>
          <ds-cb-card style="padding: 20px;">
            <ng-container *ngIf="imageBlocks?.length">
              <ds-cb-content-block-slider
                *ngIf="sliderBlock"
                [block]="sliderBlock"
              ></ds-cb-content-block-slider>
              <div class="images-grid">
                <ds-cb-image
                  *ngFor="let image of imageBlocks"
                  [class.fit]="true"
                  [block]="image"
                  [lightbox]="true"
                  [imageSize]="'icon'"
                  [fitType]="'scale'"
                ></ds-cb-image>
              </div>
            </ng-container>
            <ng-container *ngIf="!imageBlocks?.length">
              <img
                class="no-image-placeholder"
                [src]="errorSrc"
                alt="Placeholder image"
            /></ng-container>
          </ds-cb-card>
        </div>
        <div class="ds-col-sm-6 ds-col-md-4">
          <dl class="ds-fluid-text stacked">
            <dt><strong>Description</strong></dt>
            <dd itemprop="description">
              {{ item.props.publicDescription | none }}
            </dd>
            <dt><strong>Price</strong></dt>
            <dd
              itemprop="offers"
              itemscope=""
              itemtype="http://schema.org/Offer"
              class="justify-content-right"
            >
              <span *ngIf="item.isCommitted">Pending Sale</span>
              <span *ngIf="!item.isCommitted">{{ item.price | currency }}</span>
            </dd>
          </dl>
          <ds-cb-card header="Inquire About This">
            <div class="inquire-container">
              <div>
                <button
                  class="ds-button inquire-button"
                  (click)="emailUs($event)"
                >
                  <span class="icon" [inlineSVG]="'/icons/envelope.svg'"></span>
                  <span>Email Us</span>
                </button>
              </div>
              <div class="inquire-call-us">
                <span class="icon" [inlineSVG]="'/icons/phone.svg'"></span>
                <span>Call Us</span>
              </div>
              <a
                class="phone-number"
                *ngFor="
                  let number of item.physicalLocation
                    ? item.physicalLocation.phoneNumbers
                    : []
                "
                href="{{ 'tel:' + number.number }}"
              >
                {{ number.type.toLocaleUpperCase() }} {{ number.number }}
              </a>
            </div>
          </ds-cb-card>
          <ds-cb-card header="Monthly Payment Calculator">
            <ds-cb-financing-calculator
              [amount]="item.price"
              [term]="48"
              [downPayment]="0"
            ></ds-cb-financing-calculator>
            <div style="margin: 0px 25px 25px">
              <a
                class="ds-button inquire-button"
                [href]="financeUrl"
                target="_blank"
              >
                <span>Finance Application</span>
              </a>
            </div>
          </ds-cb-card>
          <!-- <ds-cb-card header="Share"> <ds-cb-share></ds-cb-share>- </ds-cb-card> -->
        </div>
        <div class="ds-col-md-4">
          <ds-cb-card header="Vehicle Details">
            <table class="ds-fluid-text detail">
              <tr *ngFor="let field of legacyDisplayFields">
                <th>{{ field.label }}</th>
                <td [innerHTML]="field.value"></td>
              </tr>
            </table>
          </ds-cb-card>
        </div>
      </div>
    </ds-cb-section>
    <ds-cb-section
      *ngIf="!isLegacy"
      class="new-version"
      [block]="sectionConfig"
    >
      <div class="ds-row-sc">
        <ds-cb-link [route]="searchLink" text="Back To Search"></ds-cb-link>
      </div>
      <div class="ds-row">
        <div class="ds-col-sm-6">
          <ds-cb-card
            style="max-width: 600px; width: 100%; padding: 20px 20px 10px 20px; margin: 0 auto;"
            backgroundColor="transparent"
            [showBorder]="false"
          >
            <ng-container *ngIf="imageBlocks?.length">
              <ds-cb-content-block-slider
                *ngIf="sliderBlock"
                [block]="sliderBlock"
              ></ds-cb-content-block-slider>
              <div class="images-grid">
                <ds-cb-image
                  *ngFor="let image of imageBlocks"
                  [class.fit]="true"
                  [block]="image"
                  [lightbox]="true"
                  [imageSize]="'icon'"
                ></ds-cb-image>
              </div>
            </ng-container>
            <ng-container *ngIf="!imageBlocks?.length">
              <img
                class="no-image-placeholder"
                [src]="errorSrc"
                alt="Placeholder image"
            /></ng-container>
          </ds-cb-card>
          <ds-cb-card
            backgroundColor="#000"
            [showBorder]="false"
            header="Description"
          >
            <ds-cb-simple-text
              class="card-item"
              [text]="item.props.publicDescription | none"
              textAlign="center"
            ></ds-cb-simple-text>
          </ds-cb-card>
          <ds-cb-card
            backgroundColor="#000"
            [showBorder]="false"
            header="Details"
          >
            <div class="inventory-details ds-row">
              <div class="ds-col-sm-6" *ngFor="let fields of displayFields">
                <table class="ds-fluid-text detail">
                  <tr *ngFor="let field of fields">
                    <th>{{ field.label }}</th>
                    <td [innerHTML]="field.value"></td>
                  </tr>
                </table>
              </div>
            </div>
          </ds-cb-card>
          <ds-cb-card
            backgroundColor="#000"
            [showBorder]="false"
            header="Finance Calculator"
          >
            <ds-cb-financing-calculator
              [amount]="item.price"
              [term]="item.isNew ? 60 : 42"
              [rate]="0"
              [downPayment]="0"
            ></ds-cb-financing-calculator>
            <div style="margin: 0px 25px 25px">
              <a
                class="ds-button inquire-button"
                [href]="financeUrl"
                target="_blank"
              >
                <span>Finance Application</span>
              </a>
            </div>
          </ds-cb-card>
        </div>
        <div class="ds-col">
          <ds-cb-card
            [showBorder]="false"
            class="contact-us-card sticky-contact-card"
          >
            <div class="inquire-container">
              <ds-cb-simple-text
                class="inventory-price"
                [text]="item.price | currency"
                fluidTextSize="xxl"
                textAlign="center"
                fontWeight="bold"
              ></ds-cb-simple-text>
              <hr />
              <ds-cb-simple-text
                text="Contact Us"
                fluidTextSize="lg"
                textAlign="center"
              ></ds-cb-simple-text>
              <a
                role="button"
                href="#"
                class="email-us-button ds-fluid-text-lg"
                (click)="emailUs($event)"
              >
                <span>Email</span>
              </a>
              <span class="or-separator ds-fluid-text-xs">OR</span>
              <a
                class="phone-number ds-fluid-text-lg"
                *ngFor="
                  let number of item.physicalLocation
                    ? item.physicalLocation.phoneNumbers
                    : []
                "
                href="{{ 'tel:' + number.number }}"
              >
                {{ number.type.toLocaleUpperCase() }} {{ number.number }}
              </a>
              <hr />
              <a
                class="ds-fluid-text-lg ds-button alt phone-number"
                [href]="financeUrl"
                target="_blank"
              >
                <span>Apply for Financing</span>
              </a>
            </div>
          </ds-cb-card>
        </div>
      </div>
    </ds-cb-section>
  `,
  styles: [
    `
      :host {
        display: block;
      }
      host-context:not(.new-version) ds-cb-card {
        margin-bottom: 15px;
      }
      table.detail {
        width: 100%;
      }
      table.detail th,
      table.detail td {
        padding: 8px;
        vertical-align: top;
        text-align: left;
      }
      .legacy table.detail td {
        border-top: 1px solid var(--ds-cb-card-border-color);
      }
      .new-version table.detail + table.detail {
        border-inline-start: 1px solid var(--ds-cb-card-border-color);
      }
      ds-cb-financing-calculator,
      .inquire-container {
        margin: 25px;
      }

      @media (max-width: 767px) {
        margin: 15px;
      }

      .inquire-container ds-cb-simple-text {
        display: block;
      }

      .inquire-container hr {
        margin: 15px 0;
      }

      .inquire-button {
        width: 100%;
        margin-bottom: 15px;
      }

      .or-separator,
      .email-us-button,
      .phone-number {
        text-align: center;
        display: block;
        width: 100%;
        margin-bottom: 10px;
      }

      .inquire-call-us {
        text-align: center;
        margin-bottom: 10px;
      }

      ds-cb-content-block-slider {
        margin-bottom: 10px;
      }

      .images-grid {
        display: grid;
        // grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        grid-template-columns: repeat(3, minmax(0, 1fr));
        grid-gap: 5px;
      }

      .new-version .images-grid {
        display: grid;
        // grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
        grid-template-columns: repeat(4, minmax(0, 1fr));
        grid-gap: 5px;
      }

      ::ng-deep ds-cb-inventory-detail ds-cb-image figure div {
        position: relative;
        width: 100%;
      }

      ::ng-deep ds-cb-inventory-detail ds-cb-image figure div:before {
        content: '';
        display: block;
        padding-top: 75%;
      }

      ::ng-deep ds-cb-inventory-detail ds-cb-image figure div img {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%;
        width: 100%;
        object-fit: cover !important;
      }

      ::ng-deep ds-cb-inventory-detail ds-cb-image figure figcaption {
        overflow: hidden;
      }

      .no-image-placeholder {
        width: 100%;
      }

      .icon {
        width: 16px;
        display: inline-block;
        margin-right: 4px;
      }

      .inventory-details th {
        width: 125px;
        max-width: 125px;
        min-width: 125px;
      }

      .sticky-contact-card {
        position: sticky;
        top: 120px;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContentBlockInventoryDetailComponent implements OnChanges, OnInit {
  imageBlocks: ImageContentBlock[];
  sliderBlock: SliderContentBlock;
  legacyDisplayFields: {
    label: string;
    value?: string | number;
  }[];

  displayFields: [
    {
      label: string;
      value?: string | number;
    }[],
    {
      label: string;
      value?: string | number;
    }[]
  ] = [[], []];

  @Input() item: Inventory = {};
  @Input() isLegacy = true;

  errorSrc = `data:image/png;base64,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`;

  sectionConfig: SectionContentBlock = new SectionContentBlock();

  financeUrl = '';

  constructor(
    private cbInvService: ContentBlockInventoryService,
    private modalService: ModalService
  ) {}

  ngOnInit() {
    this.sectionConfig.config.outerBackgroundColor = '#626262';
    this.sectionConfig.config.titlePosition = 'top-left';
    this.sectionConfig.config.title = '';
    this.sectionConfig.config.hideDivider = true;
  }

  setFinanceUrl() {
    const base =
      'https://app.trnsact.com/credit-app?vendorGUID=67e2cb94-ea87-ee11-8171-066ef92796c9';
    const price = `&price=${this.item.price}`;
    const sn = `&SN=${this.item.stockNumber}`;
    const year = `&year=${this.item.manufacturerYear}`;
    const make = `&make=${this.item.manufacturer}`;
    const model = `&model=${this.item.manufacturerModel}`;
    const condition = `&condition=${this.item.isNew ? 'new' : 'used'}`;
    const description = `&description=${this.item.manufacturerYear} ${this.item.manufacturer} ${this.item.manufacturerSeries} ${this.item.manufacturerModel}`;
    const vin = `&VIN=${this.item.vin}`;
    let pictureUrl = '';
    if (
      this.item.props.foreignImageUrls &&
      this.item.props.foreignImageUrls.length > 0
    ) {
      pictureUrl = `&pictureUrl=${this.item.props.foreignImageUrls[0]}`;
    }
    this.financeUrl = `${base}${price}${sn}${year}${make}${model}${condition}${description}${vin}${pictureUrl}`;
  }

  get searchLink() {
    return this.cbInvService.generateRoutesFromStore();
  }

  ngOnChanges(changes: any) {
    if (changes.item) {
      this.sectionConfig = {
        ...this.sectionConfig,
      };
      this.sectionConfig.config.title = `${this.item.manufacturerYear} ${this.item.manufacturer} ${this.item.manufacturerModel} ${this.item.manufacturerSeries}`;

      this.imageBlocks = this.genImageUrls();

      this.sliderBlock = {
        id: null,
        type: BlockTypeSlider,
        config: {
          imageSize: 'medium',
        },
        content: this.imageBlocks,
      };
      if (this.isLegacy) {
        this.setupLegacyDisplayFields();
      } else {
        this.setupDisplayFields();
      }
      this.setFinanceUrl();
    }
  }

  genImageUrls(): ImageContentBlock[] {
    if (this.item.isReadonly) {
      return (
        this.item.props.foreignImageUrls &&
        this.item.props.foreignImageUrls.map((photo) => ({
          id: null,
          type: BlockTypeImage,
          config: {
            label: '',
            imageSize: null,
            imageHandle: photo,
            borderColor: this.isLegacy ? null : 'transparent',
            backgroundColor: this.isLegacy ? null : 'transparent',
          },
        }))
      );
    }
    return (
      this.item.photos &&
      this.item.photos.length &&
      this.item.photos.map((photo) => ({
        id: null,
        type: BlockTypeImage,
        config: {
          label: photo.label,
          imageSize: null,
          imageHandle: photo.photoHandle,
        },
      }))
    );
  }

  emailUs($event: MouseEvent) {
    $event.preventDefault();
    this.modalService.open<void, WebsiteEmailEntry>(
      ContentBlockContactFormComponent,
      {
        type: WebsiteEmailEntryType.INVENTORY,
        inventoryId: this.item.id,
        inventoryItem: this.item,
      }
    );
  }

  setupDisplayFields() {
    this.displayFields = [
      [
        {
          label: 'Stock Number',
          value: this.item.stockNumber,
        },
        {
          label: 'Year',
          value: this.item.manufacturerYear,
        },
        {
          label: 'Make',
          value: this.item.manufacturer,
        },
        {
          label: 'Series',
          value: this.item.manufacturerSeries,
        },
        {
          label: 'Model',
          value: this.item.manufacturerModel,
        },
        {
          label: 'VIN',
          value: this.item.vin,
        },
        {
          label: 'Color',
          value: this.item.props.exteriorColor,
        },
      ],
      [
        {
          label: 'Miles',
          value: `${this.item.props.mileage || 0}`,
        },
        {
          label: 'Sleeper',
          value: this.item.props.sleeperType,
        },
        {
          label: 'Engine',
          value: `${this.item.props.engineMake} ${this.item.props.engineModel}`,
        },
        {
          label: 'Trans',
          value: `${this.item.props.transmissionMake} ${this.item.props.transmissionSpeed} Spd`,
        },
        {
          label: 'GVW',
          value: this.item.props.GVWR,
        },
        {
          label: 'Fifth Wheel',
          value: [
            'Base: ',
            this.item.props.wheelBase,
            '<br>',
            'Type: ',
            this.item.props.fifthWheelType,
          ].join(''),
        },
      ],
    ];
  }

  setupLegacyDisplayFields() {
    this.legacyDisplayFields = [
      {
        label: 'Stock Number',
        value: this.item.stockNumber,
      },
      {
        label: 'Year',
        value: this.item.manufacturerYear,
      },
      {
        label: 'Make',
        value: this.item.manufacturer,
      },
      {
        label: 'Series',
        value: this.item.manufacturerSeries,
      },
      {
        label: 'Model',
        value: this.item.manufacturerModel,
      },
      {
        label: 'VIN',
        value: this.item.vin,
      },
      {
        label: 'Style',
        value: this.item.props.duty,
      },
      {
        label: 'Miles',
        value: `${this.item.props.mileage || 0}`,
      },
      {
        label: 'Sleeper',
        value: this.item.props.sleeperType,
      },
      {
        label: 'Engine',
        value: [
          'Make: ',
          this.item.props.engineMake,
          '<br>',
          'Model: ',
          this.item.props.engineModel,
          '<br>',
          'Brake: ',
          this.item.props.engineBrake === null ||
          this.item.props.engineBrake === undefined
            ? this.item.props.engineBrake === true
              ? 'Yes'
              : 'No'
            : null,
          '<br>',
          'HP',
          this.item.props.engineHP,
        ].join(''),
      },
      {
        label: 'Trans',
        value: `${this.item.props.transmissionMake} ${this.item.props.transmissionSpeed} Spd`,
      },
      {
        label: 'GVW',
        value: this.item.props.GVWR,
      },
      {
        label: 'Fifth Wheel',
        value: [
          'Base: ',
          this.item.props.wheelBase,
          '<br>',
          'Type: ',
          this.item.props.fifthWheelType,
          '<br>',
          'Make: ',
          this.item.props.fifthWheelMake,
        ].join(''),
      },
      {
        label: 'Tire Size',
        value: this.item.props.wheelsSize,
      },
      {
        label: 'Suspension',
        value: this.item.props.suspension,
      },
      {
        label: 'Fairings',
        value: this.item.props.bodyFairings,
      },
      {
        label: 'Color',
        value: this.item.props.exteriorColor,
      },
      {
        label: 'Interior',
        value: this.item.props.cabInteriorColor,
      },
    ];
  }
}
